import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchComponent } from '../../../base/search/search.component';
import { EngagementSearchRequest } from '../../../../models/net/request/engagement-search-request';
import { EngagementSearchResult } from '../../../../models/net/result/engagement-search-result';
import { AppService } from '../../../../services/app.service';
import { EngagementService } from '../../../../services/engagements/engagement.service';
import { EngagementStatus } from '../../../../models/data/talent-core/engagement-status';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageSeverity } from '../../../../enums/message-severity';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';

@Component({
    selector: 'app-engagements',
    templateUrl: './engagements.component.html',
    styleUrls: ['./engagements.component.css', '../../../../app.component.css']
})

export class EngagementsComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["AvatarBlobPath", "ProductionName", "ResourceName", "RoleName", "EngagementStatus", "Delete"];
    public override searchRequest: EngagementSearchRequest = new EngagementSearchRequest();
    //public engagementStatuses: EngagementStatus[] = [];
    //public engagementStatusIds: number[] = [];
    public override searchResult: EngagementSearchResult[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.EngagementSearchRequest;
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: EngagementService) {

        super(appService, sessionService, itemService, "engagement", "Engagement")
        super.searchRequestTypeEnum = SearchRequestTypeEnum.EngagementSearchRequest;
    }

    public override ngOnInit(): void {

        super.ngOnInit();

        //this.itemService.getEngagementStatuses().subscribe((r: EngagementStatus[] | null) => {

        //    if (r != null) {

        //        if (r instanceof HttpErrorResponse) {

        //            this.appService.showDialog(MessageSeverity.Error, "Error Getting Statuses", "An error occurred getting engagement statuses", "OK", "", true, true);

        //        } else {

        //            this.engagementStatuses = r;
        //        }
        //    }
        //});
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: EngagementSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var searchRequest: EngagementSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (searchRequest) {

                this.runSearch(searchRequest);
            }
        });
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: EngagementSearchResult) => i.EngagementId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: EngagementSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
